import { experimental_createQueryPersister as s } from "@tanstack/query-persist-client-core";
import { QueryClient as g, useInfiniteQuery as d } from "@tanstack/react-query";
import { useEffect as l } from "react";
let c;
const m = new Uint8Array(16);
function p() {
  if (!c && (c = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !c))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return c(m);
}
const n = [];
for (let e = 0; e < 256; ++e)
  n.push((e + 256).toString(16).slice(1));
function y(e, t = 0) {
  return n[e[t + 0]] + n[e[t + 1]] + n[e[t + 2]] + n[e[t + 3]] + "-" + n[e[t + 4]] + n[e[t + 5]] + "-" + n[e[t + 6]] + n[e[t + 7]] + "-" + n[e[t + 8]] + n[e[t + 9]] + "-" + n[e[t + 10]] + n[e[t + 11]] + n[e[t + 12]] + n[e[t + 13]] + n[e[t + 14]] + n[e[t + 15]];
}
const h = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), r = {
  randomUUID: h
};
function u(e, t, f) {
  if (r.randomUUID && !e)
    return r.randomUUID();
  e = e || {};
  const o = e.random || (e.rng || p)();
  return o[6] = o[6] & 15 | 64, o[8] = o[8] & 63 | 128, y(o);
}
const a = 1e3 * 60 * 60 * 24;
var i;
const x = typeof performance < "u" && ((i = performance.getEntriesByType("navigation")[0]) == null ? void 0 : i.type) === "reload";
(x || localStorage.getItem("cacheBuster") === null) && localStorage.setItem("cacheBuster", u());
const w = s({
  storage: window.sessionStorage,
  maxAge: a,
  buster: localStorage.getItem("cacheBuster") ?? u()
}), R = new g({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: !1,
      refetchOnReconnect: !1,
      retry: !1,
      staleTime: 0,
      gcTime: a * 2
    }
  }
});
function S(e) {
  const t = d(e);
  return l(() => {
    t.hasNextPage && !t.isFetchingNextPage && t.fetchNextPage({
      cancelRefetch: !1
    });
  }, [t.hasNextPage, t.isFetchingNextPage, t.fetchNextPage]), t;
}
export {
  R as queryClient,
  w as sessionStoragePersister,
  S as useAllPages
};
